<template>
    <div class="uk-section uk-section-small uk-background-dark uk-light competition-dates" v-if="!!competition.date_CallForSubmissions || !!competition.date_ApplicationsDue || !!competition.date_SubmissionsDue || !!competition.date_FinalistsAnnounced || !!competition.date_WinnersAnnounced">
        <div class="uk-container uk-container-large">
            <div class="uk-flex uk-flex-stretch uk-grid-large" uk-grid>
                <div class="uk-width-1-3@l uk-width-2-5@m uk-width-1-1@s uk-text-right@m uk-text-center">
                    <h2 class="uk-margin-remove text-yellow"><b>Important Deadlines</b></h2>
                </div>
                <div v-bind:class="isPast(competition.date_CallForSubmissions)" v-bind:uk-tooltip="!isPast(competition.date_CallForSubmissions) ? timeLeft(competition.date_CallForSubmissions) : ''" v-if="competition.date_CallForSubmissions">
                    <label>Submissions Open</label>
                    <h3>{{ moment(competition.date_CallForSubmissions).format("MMM Do YYYY") }}</h3>
                </div>
                <div v-bind:class="isPast(competition.date_ApplicationsDue)" v-bind:uk-tooltip="!isPast(competition.date_ApplicationsDue) ? timeLeft(competition.date_ApplicationsDue) : ''" v-if="competition.date_ApplicationsDue">
                    <label>Applications Due</label>
                    <h3>{{ moment(competition.date_ApplicationsDue).format("MMM Do YYYY") }}</h3>
                </div>
                <div v-bind:class="isPast(competition.date_SubmissionsDue)" v-bind:uk-tooltip="timeLeft(competition.date_SubmissionsDue)" v-if="competition.date_SubmissionsDue">
                    <label>Submissions Deadline</label>
                    <h3>{{ moment(competition.date_SubmissionsDue).format("MMM Do YYYY") }}</h3>
                </div>
                <div v-bind:class="isPast(competition.date_FinalistsAnnounced)" v-bind:uk-tooltip="timeLeft(competition.date_FinalistsAnnounced)" v-if="competition.date_FinalistsAnnounced">
                    <label>Finalists Announced</label>
                    <h3>{{ moment(competition.date_FinalistsAnnounced).format("MMM Do YYYY") }}</h3>
                </div>
                <div v-bind:class="isPast(competition.date_WinnersAnnounced)" v-bind:uk-tooltip="timeLeft(competition.date_WinnersAnnounced)" v-if="competition.date_WinnersAnnounced">
                    <label>Winners Announced</label>
                    <h3>{{ moment(competition.date_WinnersAnnounced).format("MMM Do YYYY") }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props: ['competition'],
    methods: {
        isPast(date) {
            return new Date() >= new Date(date) ? "past" : ""
        },
        timeLeft(date) {
            return this.moment(date).endOf('day').fromNow()
        },
        moment: moment
    }
}
</script>
